import { gql, useFragment } from "@apollo/client";

// Constants
import { moduleGenSet } from "@/constants/gql-fields";

// Components
import SectionHeader from "../section-header/section-header";
import BackgroundColor from "@/components/bg-color/bg-color";
import BackgroundImage from "@/components/bg-image/bg-image";

export default function ModuleSettings({ settings, wide = false }) {
  // Fragment
  const { complete, data } = useFragment({
    fragment: ModuleSettings.fragments.entry,
    fragmentName: "ModSetFragment",
    from: {
      __typename: settings.__typename,
      id: settings.id,
    },
  });
  if (!complete) {
    return;
  }

  // - Variables
  const bgFields = data.backgroundFields;
  const titleFields = data.titleFields;
  const backgroundType = bgFields?.backgroundColorOrImage;

  return (
    <>
      {!backgroundType && typeof backgroundType != "undefined" && (
        <BackgroundColor
          colorSettings={bgFields.backgroundColor?.colorSettings}
        />
      )}
      {backgroundType && (
        <BackgroundImage
          imageSettings={bgFields.backgroundImage?.node}
          hasOverlay={bgFields.hasOverlay}
          overlayColor={bgFields.backgroundOverlay}
          textImageOpacity={bgFields.backgroundImageOpacity}
        />
      )}
      <SectionHeader
        titleFields={titleFields}
        text={data.sectionText}
        options={data.contentOptions}
        wide={wide}
      />
    </>
  );
}

ModuleSettings.fragments = {
  entry: gql`
    fragment ModSetFragment on AcfFieldGroup {
      ... on ModulesModuleContentBlockModuleSettings {
        ${moduleGenSet}
      }
      ... on ModulesModuleTextAndImageBlockModuleSettings {
        ${moduleGenSet}
      }      
      ... on ModulesModulePostsDisplayBlockModuleSettings {
        ${moduleGenSet}
      }
      ... on ModulesModuleGalleryBlockModuleSettings {
        ${moduleGenSet}
      }
      ... on ModulesModuleGravityFormBlockModuleSettings {
        ${moduleGenSet}
      }
       ... on ModulesModuleAccordionBlockModuleSettings {
        ${moduleGenSet}
      }
    }
  `,
};
